import { Spinner } from "react-bootstrap";


export default function Loader(){
    return <div className="m-5 d-flex align-items-center justify-content-center">
        <Spinner animation="grow" variant="primary" />
    </div>
}